// extracted by mini-css-extract-plugin
var _1 = "role_togglebox__LkcRJ";
export { _1 as "roleTogglebox" }
